function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 67",
  fill: "none",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 80",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 99,
  height: 61,
  rx: 11,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 97,
  height: 59,
  rx: 10
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 81",
  transform: "translate(27 66)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 6,
  rx: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 45,
  height: 4,
  rx: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 14",
  d: "M39.5 63.5h20"
}));

var SvgFrontend = function SvgFrontend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFrontend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/frontend.8eecb1e6.svg";
export { ForwardRef as ReactComponent };